"use client"

import { Suspense } from "react"
import { useSearchParams } from "next/navigation"
import Image from "next/image"
import Link from "next/link"
import { useTheme } from "@/components/ThemeProvider"
import { ThemeToggle } from "@/components/ThemeToggle"
import { NoSlotConfirmation } from "@/components/rdv/NoSlotButton"
import { FONT_MONO, FONT_SANS } from "@/lib/constants"
import { CampaignFlow } from "./CampaignFlow"
import { useRdvFlow } from "./_hooks/useRdvFlow"
import { Step1Informations } from "./_steps/Step1Informations"
import { Step2Verification } from "./_steps/Step2Verification"
import { Step3Creneaux } from "./_steps/Step3Creneaux"
import { StepIndicator } from "./_steps/StepIndicator"

export default function RdvPage() {
  return (
    <Suspense>
      <RdvPageContent />
    </Suspense>
  )
}

function RdvPageContent() {
  const searchParams = useSearchParams()
  const campaignToken = searchParams.get("ct")

  if (campaignToken) {
    return <CampaignFlow campaignToken={campaignToken} />
  }

  return <RdvStandardFlow />
}

function RdvStandardFlow() {
  const { theme } = useTheme()
  const flow = useRdvFlow()

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--ljs-bg)",
        fontFamily: FONT_SANS,
      }}
    >
      {/* Header */}
      <header
        style={{
          background: "var(--ljs-surface)",
          borderBottom: "1px solid var(--ljs-border)",
          padding: "0 24px",
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link href="/">
          <Image
            src={
              theme === "dark"
                ? "/assets/LJS PLOMBERIE_logo_clair.png"
                : "/assets/LJSPLOMBERIE_logo.png"
            }
            alt="LJS Plomberie"
            width={110}
            height={36}
            style={{ objectFit: "contain" }}
            priority
          />
        </Link>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ThemeToggle />
          <span
            style={{
              fontFamily: FONT_MONO,
              fontSize: 11,
              color: "var(--ljs-text-faint)",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
            }}
          >
            Prise de RDV
          </span>
        </div>
      </header>

      {/* Progress bar */}
      <div style={{ height: 3, background: "var(--ljs-border)" }}>
        <div
          style={{
            height: "100%",
            width: `${flow.progressPct}%`,
            background: "#0EA5E9",
            transition: "width 0.4s ease",
          }}
        />
      </div>

      <div style={{ maxWidth: 620, margin: "0 auto", padding: "32px 16px 80px" }}>
        {flow.noSlotResult ? (
          <NoSlotConfirmation alreadyRegistered={flow.noSlotResult.alreadyRegistered} />
        ) : (
          <>
            <StepIndicator step={flow.step} />

            {flow.step === 1 && <Step1Informations flow={flow} />}
            {flow.step === 2 && <Step2Verification flow={flow} />}
            {flow.step === 3 && <Step3Creneaux flow={flow} />}
          </>
        )}
      </div>
    </div>
  )
}
